export const TOOLTIP_DELAY_GENERAL = 500;
export const TOOLTIP_DELAY_ALIGNMENT_MENU = 1000;

// colors from the design system needed within js/canvas
export const COLORS = {
  '--aha-blue-500': '#0073CF',
  '--aha-purple-300': '#7F6B91',
  '--aha-teal-600': '#397E82',
  '--aha-green-700': '#4f8f0E',
  '--aha-pink-600': '#A85D74',
  '--theme-tertiary-background': 'rgb(241, 241, 241)',
  '--theme-secondary-text': '#666666',
  '--aha-orange-700': '#DE7F03',
} as const;

export const CONNECTOR_END_STYLE = {
  NONE: 0,
  POINTY_ARROW: 10,
  FILLED_ARROW: 20,
  ARROW: 25,
  FILLED_CIRCLE: 30,
  CIRCLE: 50,
  DIAMOND: 60,
  SLASH: 70,
} as const;

export type ConnectorEndStyle =
  (typeof CONNECTOR_END_STYLE)[keyof typeof CONNECTOR_END_STYLE];

export const STROKE_TYPES = {
  SOLID: 0,
  DASHED: 10,
  DOTTED: 20,
} as const;

// ShapeRecorde default sizing
export const RECORD_MINIMUM_WIDTH = 100;
export const RECORD_MINIMUM_HEIGHT = 26;

export const RECORD_DEFAULT_WIDTH = 200;
export const RECORD_DEFAULT_HEIGHT = 68;
